<template>
    <div id="implement_div">
          <p id="implement">
              Currently, there <span>{{num}}</span> at least <span id="num_programs" class="green">{{programs}}</span>
              nature based kindergarten program<span>{{s}}</span> in <span>{{article}}</span> 
              <span id="state"><select id="stateselect"  v-model="value">
                <option
                  v-for="item in schools"
                  :key="item.State"
                  :label="item.State"
                  :value="item.State">
                </option>
              </select></span>. 
              On average, the program<span>{{s}}</span> spend<span>{{s2}}</span> an estimated <span id="time_programs" class="green">{{hours}}</span>
               hours outside per week. It takes around <span class="green">5</span> acres or 
              <svg viewBox="5 0 10 15" id="city_block">
                  <image href="../assets/city_block.svg" height="100%" x="0" y="0"/>
              </svg> to run kindergarten outside. And while not all 
               <svg viewBox="5 0 5 20" id="school">
                   <image href="../assets/school.svg" height="100%" x="0" y="0"/>
               </svg> can easily switch to full time 
               <svg viewBox="5 0 5 15" id="outdoors">
                   <image href="../assets/outdoors.svg" height="100%" x="0" y="0"/>
               </svg>, it only takes <span class="green">2</span> hours spent outside per week to make a difference
                for the students. Even in a densely populated city like 
                <span id="city">
                  <select v-model="value2">
                      <option v-for="c in land" :key="c.City">{{c.City}}</option>
                    </select>
                 </span> 
                  there are <span id="acres" class="green">{{acres}}</span> acres of 
                  <svg viewBox="10 0 5 15" id="green_space">
                      <image href="../assets/green_space.svg" height="100%" x="0" y="0"/>
                  </svg>, meaning that, in theory, there is enough space to hold 
                <span id="potential_programs" class="green">{{potential}}</span> outdoor kindergarten programs.
          </p>
      </div>
      <div id="learn">
          <div id="learn_text"><p id="lt">Learn More:</p></div>
          <div id="btn1"><a target="_blank" href="https://medium.com/communityworksjournal/taking-the-classroom-to-the-forest-a-schools-forest-fridays-program-3b95b525c070"><p class="bttn">Hybrid Programs <img src="../assets/ext.png" alt=""></p></a></div>
          <div id="btn2"><a target="_blank" href="https://cedarsongway.org/"><p class="bttn">Curriculum <img src="../assets/ext.png" alt=""></p></a></div>
          <div id="btn3"><a target="_blank" href="http://naturalstart.org/resources"><p class="bttn">Other Resources <img src="../assets/ext.png" alt=""></p></a></div>
      </div>
</template>

<script>
import schools from '../assets/schools.json'
import land from '../assets/land.json'


export default {
  name: 'implement',
  data() {
    return {
      schools: schools,
      value: 'United States',
      land: land,
      value2: 'Albuquerque, NM'
    }
  },
  computed: {
    programs: function() {
        return schools.find(o => o.State === this.value).Programs
    },
    hours: function() {
        return Math.round(schools.find(o => o.State === this.value).Hours)
    },
    acres: function() {
        return land.find(o => o.City === this.value2).Acres
    },
    potential: function() {
        function formatNumber(num) {
          return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        }
        if (this.value2 != ''){
        return formatNumber(Math.round(land.find(o => o.City === this.value2).Potential))
        } else { return formatNumber(Math.round(land[0].Potential))}
    },
    article: function() {
        if (this.value == '' || this.value == "United States"){
        return "the "
        } else { return ''}
    },
    num: function() {
        if (["Hawaii","Mississippi","Nevada","North Dakota","Rhode Island","South Dakota","Wyoming"].includes(this.value)){
        return "is"
        } else { return "are"}
    },
    s: function() {
        if (["Hawaii","Mississippi","Nevada","North Dakota","Rhode Island","South Dakota","Wyoming"].includes(this.value)){
        return ""
        } else { return "s"}
    },
    s2: function() {
        if (["Hawaii","Mississippi","Nevada","North Dakota","Rhode Island","South Dakota","Wyoming"].includes(this.value)){
        return "s"
        } else { return ""}
    }
  },
  components: {
  },
  setup() {
  }
}
</script>

<style>
#implement_div {
    min-height: 100%;
    width: 100%;
}

#implement {
    color: 	white;
    font-family: Josefin;
    font-size: 2.7vw;
    padding: 0 5% 0 5%;
    line-height: 1.8;
    margin: 1% 2% 0 2%;
}

.green {
    background-color: #42694c;
    color: white;
    font-size: 3vw;
    padding-left: 4px;
    padding-right: 4px;
    border-radius: 5px;
}

#learn {
    margin-left: 20%;
    margin-right:20%;
    width: 60%;
}

#learn_text, #btn1, #btn2, #btn3 {
    float: left;
    font-family: Josefin;
    width: 21%;
    margin: 3% 1.5% 3% 2.5%;
    padding-top: 3px;
    padding-bottom: 2px;
}

.bttn {
    border-radius: 5px;
    border-style: solid;
    border-width: 1px;
}

.bttn:hover {
    background-color: #46755280;
}

a {
    text-decoration: none;
}

/*a[target="_blank"]:after {*/
/*    content: url(../assets/ext.png);*/
/*}*/

#lt, .bttn {
    text-align:center;
    background-color: #46755200;
    color: white;
    padding: 1.5%;
    font-size: 1.5vw;
    font-family: Josefin;
}

#city_block {
    height: 73.5px;
    width: 98px;
    vertical-align: middle;
}

#school {
    height: 75.2px;
    width: 80px;
    vertical-align: middle;
}

#outdoors {
    height: 72px;
    width: 80px;
    vertical-align: middle;
}

#green_space {
    height: 72px;
    width: 144px;
    vertical-align: middle;
}

select {
    background-color: #98979700;
    color: #42694c;
    font-family: JosefinB;
    font-size: 2vw;
    border-radius: 5px;
    border-color: white;
}
</style>
